export function decode(component) {
    return component.replace(/!([0-9a-f]{2})/gi, function (match, code) { return String.fromCharCode(parseInt(code, 16)); });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/firebase-key/dist/key-decode.js
// module id = 2185
// module chunks = 0